import { clientPublicStore } from "@packages/stores";
import { Pages } from "@packages/utils/enums";
import type { Passport } from "@src/Passport";
import { get } from "svelte/store";

export const getClientConfigByClientId = (
  clientId: string,
): {
  name: string;
  minStoredValueToPurchase: number;
  maxStoredValueToPurchase: number;
  payment: {
    paystack?: string;
    stripe: string;
  };
} => {
  switch (clientId) {
    case "6756b6f8c7d313c0d6ca03f0":
    case "65a510cd9415d41b1aa933dc":
      return {
        name: "OH",
        minStoredValueToPurchase: 10,
        maxStoredValueToPurchase: 5000,
        payment: {
          stripe: "USD",
          paystack: "GHS",
        },
      };
    default:
      return {
        name: "DEFAULT",
        minStoredValueToPurchase: 0,
        maxStoredValueToPurchase: 100,
        payment: {
          stripe: "USD",
        },
      };
  }
};

export const getClientSettings = async (apiUrl: string, clientId: string) => {
  const result = await fetch(`${apiUrl}/clients/${clientId}/public`, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const json = await result.json();
  if (!result.ok) throw new Error(json.error);
  json.ui_settings = Object.assign(
    { stored_value_alias: "stored value", cred_alias: "CRED" },
    json.ui_settings,
  );

  return json;
};

export const openClientWelcomMessage = (openUI: Passport["openUI"]) => {
  const {
    ui_settings: { welcome_title, welcome_text },
  } = get(clientPublicStore);
  if (!welcome_title && !welcome_text) return;

  openUI(Pages.WELCOME);
};
